/**
 * The Wealthoak logo: the supplied artwork (public/brand/wealthoak-logo.webp)
 * as a cream tile with the "W." centred in it. The letter's edges are
 * measured from the photo so the margins are equal left/right and
 * top/bottom; a plain crop of the photo left it small and up-left. The same
 * file is the favicon in index.html and the IRA launcher's mark.
 *
 * Decorative only: every place it appears already carries the name as text
 * or an aria-label, so the alt text is empty.
 */
export const LOGO_SRC = "/brand/logo-mark.png";

export default function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <img
      className="brand-mark"
      src={LOGO_SRC}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
    />
  );
}
